import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import { minDate } from "../../Constants/Constants";

const AddStaffDetailsModal = ({ getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const formRef = useRef(null);
  const [companyId, setCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const [rowAddData, setRowAddData] = useState({
    staff_name: "",
    staff_position: "",
    mob_num: "",
    employee_from_date: "",
    exit_from_date: "",
  });
  function resetFileds() {
    setRowAddData({
      staff_name: "",
      staff_position: "",
      mob_num: "",
      employee_from_date: "",
      exit_from_date: "",
    });
    setCompanyId("");
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };
  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      staff_name,
      staff_position,
      mob_num,
      employee_from_date,
      exit_from_date,
    } = rowAddData;
    const from_date = moment
      .utc(employee_from_date, "YYYY-MM-DD")
      .toISOString();
    const exit_date = moment.utc(exit_from_date, "YYYY-MM-DD").toISOString();
    let BASE_URL = SERVER_URL + `/api/staff-detials/staffDetails/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: companyId,
        staff_name,
        staff_position,
        mob_num,
        employee_from_date: from_date,
        exit_from_date: exit_date,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      resetFileds();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useState(() => {
    getCompany();
  }, []);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="staffModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Staff Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Staff Details</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={companyId}
                              required
                              autoComplete="off"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option value={item.id}>
                                        {`${item.company_name}, ${item.location}`}
                                      </option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Product">Employee Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="staff_name"
                              id="Product"
                              placeholder="Employee Name"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.staff_name}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Quantity">Employee Position</label>
                            <input
                              type="text"
                              className="form-control"
                              name="staff_position"
                              id="Quantity"
                              placeholder="Employee Position"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.staff_position}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Size">Mo Number</label>
                            <input
                              type="number"
                              className="form-control"
                              name="mob_num"
                              id="Size"
                              placeholder="Mo Number"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.mob_num}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="date">Employee From Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="employee_from_date"
                              id="date"
                              placeholder="Employee From Date"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              value={rowAddData.employee_from_date}
                              // min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="date">Exit From Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="exit_from_date"
                              id="date"
                              placeholder="Exit From Date"
                              onChange={handleChange}
                              // required
                              autoComplete="off"
                              value={rowAddData.exit_from_date}
                              // min={minDate}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddStaffDetailsModal;
